import { Injectable } from '@angular/core';

import { AppConf, HttpService } from '@contact/upgrade';

@Injectable({
  providedIn: 'root',
})
export class AgentImageService {
  private agentPictures = new Map();
  private chatBaseUrl: string;
  private controllerMapping = 'profile-picture';

  constructor(private readonly http: HttpService, private readonly appConf: AppConf) {
    this.appConf.subscribe(({ chat }) => (this.chatBaseUrl = (chat?.chatBaseUrl || '') + '/api'));
  }

  getPicture(csrId: string): string | undefined {
    return this.agentPictures.get(csrId);
  }

  setPicture(csrId: string, picture: any): Map<string, string> {
    return this.agentPictures.set(csrId, picture);
  }

  loadImage(csrId: string) {
    if (csrId && !this.agentPictures.has(csrId)) {
      this.http
        .get(this.chatBaseUrl + '/' + this.controllerMapping + '/' + csrId, {
          observe: 'response',
          responseType: 'text',
        })
        .subscribe((data: any) => {
          if (data.body) {
            this.agentPictures.set(csrId, data.body);
          } else {
            this.agentPictures.set(csrId, '');
          }
        });
    }
  }
}
